// @flow
import type {Node} from 'react'
import React, {Component} from 'react'

import type {PartProps} from 'components/proposals/Part/Role/types'
import SummaryUI from 'components/proposals/Part/ui/Summary'
import SummarySections from 'components/proposals/Part/SummarySections'
// eslint-disable-next-line import/named
import {Severity} from 'components/ui/Alert'

type Props = PartProps

class Summary extends Component<Props> {
  get mightLoseChanges(): boolean {
    return !!(this.props.destroyRole || this.destroyCircleEntirely)
  }

  get destroyCircleEntirely(): boolean {
    return this.props.destroyCircle
      && !this.props.destroyCircleKeepRole
  }

  get alertSeverity(): null | Severity {
    if (this.props.destroyRole || this.props.destroyCircle)
      return Severity.Warning
    if (this.props.expandRole)
      return Severity.Info
    return null
  }

  get alertMessage(): null | string {
    if (this.props.destroyRole)
      return I18n.t('proposal.sentences.role_will_be_removed')
    if (this.destroyCircleEntirely)
      return I18n.t('proposal.sentences.circle_will_be_deleted')
    if (this.props.destroyCircle)
      return I18n.t('proposal.sentences.circle_will_be_collapsed')
    if (this.props.expandRole)
      return I18n.t('proposal.sentences.role_will_become_circle')
    return null
  }

  render(): Node {
    return (
      <SummaryUI
        alertMessage={this.alertMessage}
        alertSeverity={this.alertSeverity}
        lostChanges={this.mightLoseChanges}
      >
        <SummarySections change={this.props.change} />
      </SummaryUI>
    )
  }
}

export default Summary
